import {apiGetDetail, apiLogin, apiLogout} from '@/api/common/auth.js'
import {getToken, setToken, removeToken} from '@/utils/token.js'
import useRoutesStore from "@/store/modules/routes.js";
// import defAva from '@/assets/images/profile.jpg'

const useUserStore = defineStore(
    'user',
    {
        state: () => ({
            token: getToken(),
            username: '',
            nickname: '',
            avatar: '',
            roles: [],
            permissions: [],
            timestamp: 0,
            manager: false,
            authorityId: -1,
            authorities: [],
        }),
        actions: {
            // 登录
            async login(userInfo) {
                const {username, password} = userInfo;
                try {
                    const {code ,data} = await apiLogin(userInfo);
                    if (code === 200) {
                        setToken(data);
                        this.token = data;
                    }else {
                        this.resetData()
                    }
                    return Promise.resolve();
                } catch (error) {
                    return Promise.reject(error);
                }
            },
            // 获取用户信息
            async getDetail() {
                try {
                    const res = await apiGetDetail();
                    const {code,data,timestamp} = res;
                    if (code === 200) {
                        const user = data.user;
                        const avatar = user.avatar === "" || user.avatar == null ?
                            null : user.avatar;
                        if (data.roles && data.roles.length > 0) {
                            this.roles = data.roles;
                            this.permissions = data.permissions;
                        }
                        this.username = user.username;
                        this.nickname = user.nickname;
                        this.avatar = avatar;
                        this.authorityId = user.authorityId;
                        this.manager = user.manager === 0;
                        this.timestamp = timestamp;
                        this.authorities = user.authorities
                        return Promise.resolve(res);
                    }else {
                        this.resetData()
                        return Promise.reject();
                    }

                } catch (error) {
                    return Promise.reject(error);
                }
            },
            // 退出系统
            async logout() {
                try {
                    await apiLogout();
                    return Promise.resolve();
                } catch (error) {
                    return Promise.reject(error);
                } finally {
                    this.resetData()
                }
            },
            resetData () {
                this.token = null
                this.username = null
                this.nickname = null
                this.avatar = null
                this.token = null;
                this.roles = [];
                this.permissions = [];
                this.timestamp = -1;
                this.manager = false;
                this.authorityId= -1;
                this.authorities = []
                useRoutesStore().routes = []
                removeToken();
            }
        }
    })

export default useUserStore
